<template>
    <div class="tab-pane active">
        <app-button v-if="$store.getters.canEditSettings" native-type="button" type="success" class="float-right" @click="$modal.show('create_promocode')">
            {{ $t('Create') }}
        </app-button>
        <div class="clearfix"></div>
        <div class="table-responsive">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('Code') }}</th>
                        <th>{{ $t('Start') }}</th>
                        <th>{{ $t('End') }}</th>
                        <th>{{ $t('Discount') }} %</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(promocode, i) in promocodes" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ promocode.code }}</td>
                        <td>{{ promocode.start_date | formatDate }}</td>
                        <td>{{ promocode.end_date | formatDate }}</td>
                        <td>{{ promocode.discount_percent }}</td>
                        <td class="p-0">
                            <div class="text-right">
                                <router-link v-if="$store.getters.canViewSettings" :to="{name: 'promocodes.show', params: {promocode_id: promocode.id}}" class="btn btn-info btn-sm text-white">
                                    {{ $t('View') }}
                                </router-link>
                                <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_promocode', {promocode})" class="ml-2" small>
                                    {{ $t('Edit') }}
                                </app-button>
                                <app-button v-if="$store.getters.canDeleteSettings" native-type="button" type="danger" @click="destroy(promocode.id)" small>
                                    {{ $t('Delete') }}
                                </app-button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <create-modal @setPromocode="setPromocode"/>
        <update-modal @setPromocode="setPromocode"/>
    </div>
</template>

<script>
import PromocodeService from '@services/promocode.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import {mapGetters} from 'vuex';
import Vue from 'vue';

export default {
    data() {
        return {
            promocodes: []
        };
    },
    computed: {
        ...mapGetters(['locale'])
    },
    methods: {
        getPromocodes() {
            PromocodeService.promocodes().then(res => this.promocodes = res);
        },
        setPromocode(promocode) {
            const index = this.promocodes.findIndex(p => p.id === promocode.id);
            if(index !== -1) {
                Vue.set(this.promocodes, index, promocode);
            } else {
                this.promocodes.push(promocode);
            }
        },
        destroy(promocodeId) {
            if(!window.confirm(`${this.$t('Delete')}?`)) {
                return false;
            }
            PromocodeService.destroy(promocodeId).then(res => {
                const index = this.promocodes.findIndex(p => p.id === promocodeId);
                this.promocodes.splice(index, 1);
                this.$toastr.s(this.$t('Deleted'));
            });
        }
    },
    components: {
        CreateModal,
        UpdateModal
    },
    created() {
        this.getPromocodes();
    },
    metaInfo() {
        return {
            title: this.$t('Promocodes')
        };
    }
};
</script>
